
import Homesection from "../../pages/Home/Homesection";

function Home(){
    return(
        <div>

            <Homesection/>
        </div>
    )
}

export default Home;